import { useState, Fragment } from "react";
import { Icons } from "components/Icons";
import { Col } from "styles";
import { hbPreNecropsyConfig } from "utils/globalData";
import {
  ItemScore,
  ItemScoreTitle,
  ItemScoreProgress,
  ItemScoreNumber,
} from "../style";

export function BoxProduction({ param, response }) {
  const config = hbPreNecropsyConfig.production[param];
  const { productionBoxes } = response;
  const [showScores, setShowScores] = useState(true);
  return (
    <Col>
      <ItemScore onClick={() => setShowScores(!showScores)}>
        <Icons type="preNecropsy" size={24} color={config.color} />
        <ItemScoreTitle>{config.label}</ItemScoreTitle>
        {config.measure === "%" && (
          <ItemScoreProgress>
            <div
              role="progressbar"
              aria-valuemin="0"
              aria-valuenow="100"
              aria-valuemax="100"
              style={{
                width: `${(
                  productionBoxes
                    .map((item) => item[param])
                    .reduce((a, b) => a + b) / productionBoxes.length
                ).toFixed(0)}%`,
                backgroundColor: config.color,
              }}
            >
              <span>
                {(
                  productionBoxes
                    .map((item) => item[param])
                    .reduce((a, b) => a + b) / productionBoxes.length
                ).toFixed(0)}
                {param === "weight" ? "g" : "%"}
              </span>
            </div>
          </ItemScoreProgress>
        )}
        {showScores &&
          productionBoxes
            .sort(function (a, b) {
              return a.lote < b.lote ? -1 : a.lote > b.lote ? 1 : 0;
            })
            .map((item) => (
              <Fragment key={item.lote}>
                <ItemScoreNumber>
                  <div style={{ width: "100%" }}>
                    <b>Lote {item.lote}</b>
                  </div>
                  <div>
                    {item[param].toFixed(0)}
                    {config.measure}
                  </div>
                </ItemScoreNumber>
                {config.measure === "%" && (
                  <ItemScoreProgress>
                    <div
                      role="progressbar"
                      aria-valuemin="0"
                      aria-valuenow="100"
                      aria-valuemax="100"
                      style={{
                        width: `${item[param].toFixed(0)}%`,
                        backgroundColor: config.color,
                      }}
                    ></div>
                  </ItemScoreProgress>
                )}
              </Fragment>
            ))}
      </ItemScore>
    </Col>
  );
}
